<template>
  <div class="u-wrap">
    <div class="card">
      <van-form>
        <van-field
          :required="true"
          v-model="model.phone"
          label="联系方式"
          placeholder="请输入手机号码"
          input-align="right"
        />
        <van-field :required="true" v-model="sms" center clearable label="短信验证码" placeholder="请输入短信验证码">
          <template #button>
            <van-button v-if="senMsg_type == 1" size="small" type="primary" @click="sendMsg">{{ sendTxt }}</van-button>
            <van-button v-if="senMsg_type == 2" size="small" type="primary">{{ secodes }}s 重新获取</van-button>
          </template>
        </van-field>

        <van-popup v-model="show" position="bottom">
          <van-picker show-toolbar :columns="columns" @confirm="onConfirm" @cancel="show = false" value-key="title" />
        </van-popup>
      </van-form>
    </div>
    <div class="b-btn">
      <button class="b-button" :disabled="disable" @click="clickSumbit">提交</button>
    </div>
  </div>
</template>

<script>
import { getAction, putAction } from '@/api/manage'
import uSelect from '@/components/page/u-select.vue'
import { isMobile, isCardID } from '@/utils/validate'
import { Toast } from 'vant'
export default {
  components: {
    uSelect,
  },
  data() {
    return {
      url: '/sys/detectauth/check/by/phone',
      model: {
        sysOrgCode: '',
        wechatName: '',
        phone: '',
        idNumber: '',
        gzdw: '', //工作单位
        hkdz: '', //户口地址
        xjzdz: '', //现居住地址
        smrzHjqk: '', //户籍情况
        sysOrgCode_dictText: '',
        openId: '',
      },
      sms: '',
      show: false,
      columns: [],
      senMsg_type: 1,
      secodes: 60,
      myTimer: null,
      sendTxt: '发送验证码',
    }
  },
  created() {
    let params = this.$route.query
    if (params != null && params.phone) {
      this.model = params
    }
  },
  computed: {
    disable() {
      let disable = true
      if (this.model.phone && this.sms) {
        disable = false
      }

      return disable
    },
  },
  methods: {
    change(index) {
      this.currentTab = index
    },
    clickSumbit() {
      if (!isMobile(this.model.phone)) {
        this.$toast('请输入正确手机号码')
        return
      }

      this.model.openId = this.$store.getters.openId 
      let params = {
        phone: this.model.phone,
        verificationCode: this.sms,
      }
      getAction('/sys/mlogin/verify/verification', params).then((res) => {
        if (res.code == 200) {
          this.$router.replace({ name: 'smrz', query: { phone: this.model.phone } })
          // getAction(this.url, params).then((res) => {
          //   if (res.success) {
          //     if (res.result) {
          //       this.rzInfo = res.result;
          //       this.showDialog();
          //     } else {
          //       this.$router.replace({ name: 'smrz', query: { phone: this.model.phone } })
          //     }
          //   }
          // })
        } else {
          this.$toast('验证码错误')
        }
      })
    },
    detectauth(){
     let url = '/system/sysuserwechatbind/detectauth/by/phone';
           this.rzInfo.openId = this.$store.getters.openId
          getAction(url, this.rzInfo).then((res) => {
          })
    },
    showDialog() {
      this.$dialog
        .alert({
          title: '提示',
          message: '该手机号已进行实名认证，请点击“确定”使用公众号',
          confirmButtonText: '确定',
          confirmButtonColor: '#3f8ffb',
        })
        .then(() => {
          this.$router.go(-1)
          this.detectauth();
        })
    },
    onConfirm(value, index) {
      this.model.sysOrgCode_dictText = value.join('-')
      let index1 = index[0]
      let index2 = index[1]
      let index3 = index[2]
      try {
        let sysOrgCode = this.columns[index1].children[index2].children[index3].orgCode
        this.model.sysOrgCode = sysOrgCode
      } catch (error) {}

      this.show = false
    },

    sendMsg() {
      if (this.model.phone == '') {
        Toast('请输入手机号')
        return
      }
      if (!isMobile(this.model.phone)) {
        this.$toast('请输入正确手机号码')
        return
      }
      let params = {
        sendFlag: true,
        phone: this.model.phone,
      }
      getAction('/sys/mlogin/send/verification', params).then((res) => {
        console.log('res', res)
      })
      this.getSecodes()
    },
    getSecodes() {
      this.secodes = 60
      this.senMsg_type = 2
      this.myTimer = setInterval(() => {
        this.secodes--
        console.log('倒计时', this.secodes)
        if (this.secodes <= 0) {
          this.secodes = 0
          this.senMsg_type = 1
          this.sendTxt = '重新获取'
          console.log('清除倒计时')
          clearInterval(this.myTimer)
        }
      }, 1000)
    },
  },
  beforeDestory() {
    clearInterval(this.myTimer)
  },
}
</script>

<style lang="less" scoped>
.u-wrap {
  height: 100vh;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  background-color: #f5f5f5;
}
.u-wrap /deep/ .van-button--primary {
  background-color: #3f8ffb;
  border: 1px solid #3f8ffb;
}
.heard {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  z-index: 1;
}
.u-content-wrap {
  flex: 1;
  display: flex;
}

.card {
  background: #ffffff;
  padding: 0px;
  margin: 12px 8px 0px;
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.04);
  border-radius: 5px;
  overflow: hidden;
  height: auto;
  margin-bottom: 60px;
}

.xxnr {
  width: 90%;
  margin: 0 12px;
  height: 128px;
  border-radius: 5px;
  border: 1px solid #ededed;
  padding: 8px;
  font-size: 14px;
}

.tips {
  padding: 12px;
  color: #999999;
  line-height: 18px;
  font-size: 12px;
  display: flex;
}

.tip {
  flex: 1;
  margin-left: 6px;
}

.sjcl-bottom {
  height: 60px;
  width: 96%;
  background: #ffffff;
  position: fixed;
  bottom: 0px;
  padding: 0px 10px;
  align-items: center;
  justify-content: center;
  display: flex;
  box-shadow: 0px -3px 8px 0px rgba(216, 216, 216, 0.5);
  .voice-mode {
    flex: 1;
    margin-left: 10px;
    height: 40px;
    font-size: 16px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(211, 211, 211, 1);
    border-radius: 5px;
    text-align: center;
    line-height: 40px;
  }
}

.b-btn {
  padding: 0 20px;

  .b-button {
    width: 100%;
    height: 44px;
    background: #3f8ffb;
    border-radius: 5px;
    opacity: 1;
    border: none;
    color: #ffffff;
  }

  .b-button[disabled] {
    opacity: 0.48;
  }
}
</style>
